import { CategoryFilter } from "./category-filter";
export const ShopFilters: React.FC = () => {
  return <div className="pt-1" data-sentry-component="ShopFilters" data-sentry-source-file="filters.tsx">
			<div className="hidden border-b border-neutral-300 dark:border-neutral-600 md:block md:pb-7 md:mb-7">
			</div>
			<CategoryFilter data-sentry-element="CategoryFilter" data-sentry-source-file="filters.tsx" />
		</div>;
};